import { useMutation } from "react-apollo"
import gql from "graphql-tag"
import { useShowSuccessToast } from "gatsby-interface"
import updatePreviewTargetCache from "../utils/updatePreviewTargetCache"
import { HostingDetailsForSiteDocument } from "@modules/cdn/gatsbyCloudCdn/queries.generated"

const SET_SITE_PREVIEW_TARGETS = gql`
  mutation setSitePreviewTargets(
    $siteId: UUID!
    $directoryPath: String!
    $branch: String!
    $description: String
    $publicName: String
    $sitePrefix: String
  ) {
    setSitePreviewTargets(
      siteId: $siteId
      directoryPath: $directoryPath
      branch: $branch
      description: $description
      publicName: $publicName
      sitePrefix: $sitePrefix
    ) {
      success
      message
      errorType
    }
  }
`

export default function useSetPreviewTargets(siteId) {
  const [setPreviewTargetsMutation, { loading }] = useMutation(
    SET_SITE_PREVIEW_TARGETS
  )

  const showSuccessToast = useShowSuccessToast()

  const setPreviewTargets = ({
    branch,
    directoryPath,
    successMessage,
    description,
    publicName,
    sitePrefix,
    isHostedOnGatsby,
  }) => {
    const variables = {
      siteId,
      branch,
      description,
      directoryPath,
      publicName,
      sitePrefix,
    }

    return setPreviewTargetsMutation({
      variables,
      update: updatePreviewTargetCache(
        siteId,
        branch,
        directoryPath,
        description,
        publicName,
        sitePrefix
      ),
      refetchQueries: isHostedOnGatsby && [
        {
          query: HostingDetailsForSiteDocument,
          variables: { siteId },
        },
      ],
    }).then(({ data }) => {
      const {
        setSitePreviewTargets: { success, message },
      } = data
      if (success) {
        return showSuccessToast(successMessage)
      }

      throw new Error(message)
    })
  }

  return [setPreviewTargets, loading]
}
